module.exports = __webpack_public_path__ + "img/CS-Lite-Vol_SpareB_1.9979f648.jpg";